import { render } from "./Konfigurasi.vue?vue&type=template&id=6d61f19e"
import script from "./Konfigurasi.vue?vue&type=script&lang=js"
export * from "./Konfigurasi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__